import script from "./BaseTextForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseTextForm.vue?vue&type=script&lang=ts&setup=true"

import "./BaseTextForm.vue?vue&type=style&index=0&id=7ed785d0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed785d0"]])

export default __exports__